module.exports = __webpack_public_path__ + "img/921_page_background_people4_pc.e4cbfcc0.jpg";